export enum DropdownType {
  GeneralInfo,
  Items,
  ScopeOfWork,
}
